// client/src/components/help/HelpSection.js
// Collapsible help section with multiple articles
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const HelpSection = ({ title, icon, articles, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="mb-6 border border-gray-200 rounded-lg overflow-hidden">
      {/* Section Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-6 py-4 bg-gradient-to-r from-blue-50 to-white hover:from-blue-100 hover:to-blue-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-2xl">{icon}</span>
          <h2 className="text-xl font-bold text-gray-900">{title}</h2>
        </div>
        {isOpen ? (
          <ChevronUp className="w-6 h-6 text-blue-600" />
        ) : (
          <ChevronDown className="w-6 h-6 text-gray-400" />
        )}
      </button>

      {/* Articles List */}
      {isOpen && (
        <div className="px-6 py-4 bg-white">
          <div className="space-y-3">
            {articles.map((article, index) => (
              <div
                key={index}
                className="group border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm transition-all cursor-pointer"
              >
                <div className="flex items-start gap-3">
                  {article.icon && (
                    <span className="text-xl mt-1 flex-shrink-0">{article.icon}</span>
                  )}
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                      {article.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpSection;